module.exports = __webpack_public_path__ + "img/fj.76a7a39e.svg";